import { render, staticRenderFns } from "./inviteCrew.vue?vue&type=template&id=a55bfbaa"
import script from "./inviteCrew.vue?vue&type=script&lang=js"
export * from "./inviteCrew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports